export var LOADING_STATE = {
    CHANGE_ARTICLE_DRAFT_STATE: function (fileId) { return "changeArticleDraftState-".concat(fileId); },
    CHANGE_INSTRUCTION_DRAFT_STATE: function (fileId) { return "changeInstructionDraftState-".concat(fileId); },
    DELETE_GENERATED_ARTICLE: function (fileId) { return "deleteGeneratedArticle-".concat(fileId); },
    DELETE_GENERATED_INSTRUCTION: function (fileId) { return "deleteGeneratedInstruction-".concat(fileId); },
    GET_ARTICLE_CONTENT: function (fileId) { return "getArticleContent-".concat(fileId); },
    UPDATE_ARTICLE_CONTENT: function (fileId) { return "updateArticleContent-".concat(fileId); },
    UPDATE_INSTRUCTION_CONTENT: function (fileId) { return "updateInstructionContent-".concat(fileId); },
};
